import Pagination from '../../../common/models/Pagination';

export default class OperationFiltersModel extends Pagination {
  constructor(obj) {
    obj = obj || {};
    super(obj);

    this.startDate = obj.startDate;
    this.endDate = obj.endDate;
    this.statusList = obj.statusList;
    this.exchangeTypeId = obj.exchangeTypeId;
    this.natureId = obj.natureId;
    this.exchangeBuy = obj.exchangeBuy;
    this.currencyId = obj.currencyId;
    this.bankList = obj.bankList;
    this.agentId = obj.agentId;
    this.idPersonType = obj.idPersonType;
    this.cpfCnpj = obj.cpfCnpj;
    this.customerId = obj.customerId;
    this.indicatorId = obj.indicatorId;
    this.excludeDigitalCurrency = obj.excludeDigitalCurrency;
    this.searchText = obj.searchText;
    this.periodPreset = obj.periodPreset ?? null;
    this.duimpStatusList = obj.duimpStatusList;
  }
}
